import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import Block from "../Block/Block";

function Passport() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>Philippine Passport application for German citizens with Philippine heritage.</BlockTitle>
          <BlockSubtitle>As a German citizen born in Germany to Filipino parents, you are also recognized as a Filipino citizen by birth, affording you specific rights, such as eligibility for a Philippine passport. This article provides a detailed step-by-step guide on how to apply for a Philippine passport.</BlockSubtitle>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Preface</BlockSubtitle>
            <BlockText>The following guide is based on personal experiences when applying for an E-Passport in the Philippines without an existing birth registration (see <a href="http://philippine-embassy.de/passports/">New Application (Adults)</a>). Depending on the circumstances you bring to the application process, it may be easier or more complex. In my case, the following conditions applied:
            <ul>
              <li>At the time of my birth, my mother held Philippine citizenship, while my father was German.</li>
              <li>My mother renounced her Philippine citizenship in favor of German citizenship after my birth.</li>
              <li>My birth was not registered in the Philippines.</li>
              <li>My parents' marriage was not registered in the Philippines. Registration through the "Report of Marriage" document was not possible, as one of the parents had already passed away.</li>
              <li>The birth certificate of my Philippine mother was not available with the Philippine Statistics Authority (PSA) in the Philippines.</li>
              <li>I still possessed my first Philippine Passport, which had already expired.</li>
            </ul>
            To understand the steps to be taken in such a scenario, please refer to the following points.
          </BlockText>
        </BlockContent>
      </Block>
      
      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Requirement</BlockSubtitle>
            <BlockText>One of the parents must have held Philippine citizenship at the time of the applicant's birth. If this citizenship is renounced after birth, it does not affect the applicant's right to be eligible for Philippine citizenship. However, if citizenship was renounced prior to birth, there is unfortunately no avenue to apply for a passport through this method.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Documents</BlockSubtitle>
            <BlockText>
            For the birth registration:
            <ul>
              <li><a href="http://philippine-embassy.de/wp-content/uploads/2022/12/ROB_Checklist_Requirements_rev_Nov2022_.pdf">Checklist of Requirements for Filing a Report of Birth of a Filipino National</a></li>
              <li><a href="http://philippine-embassy.de/wp-content/uploads/2022/12/ROB_Form_2023_rev_Nov2022.pdf">Report of Birth Application Form</a></li>
              <li>Extract from birth registration - Auszug aus dem Geburtseintrag (Formule A, request <a href="https://service.berlin.de/dienstleistung/318960/">here</a>)</li>
              <li>Identification Card - Personalausweis (copies of front and back)</li>
              <li><a href="http://philippine-embassy.de/wp-content/uploads/2022/10/ROB_Aff_Delayed_Reg_2022_rev_Nov2022.pdf">Affidavit of Delayed Registration</a></li>
              <li>PSA-issued Negative Certification of Birth (CSR Form No. 1, request <a href="https://www.psaserbilis.com.ph/#!">here</a>)</li>
              <li>Original German Passport of the Filipino Parent (copy of data page)</li>
              <li>Original Philippine Passport of the Filipino Parent (copy of data page)</li>
            </ul>
            Supporting Documents:
            <ul>
              <li>Affidavit of Explanation for the non-report of the previous marriage</li>
              <li>Extract from marriage registration - Auszug aus dem Heiratseintrag (Formule B, request <a href="https://service.berlin.de/dienstleistung/318969/">here</a>)</li>
              <li>PSA-Issued Negative Certification of Birth of the Philippine Parent (CSR Form 1, request <a href="https://www.psaserbilis.com.ph/#!">here</a>)</li>
              <li>PSA-Issued Certificate of no Marriage Record (CSR Form 3, request <a href="https://www.psaserbilis.com.ph/#!">here</a>)</li>
              <li>Certification of my Mother's Birth from the Local Civil Registrar (only necessary because no birth record was available at the PSA)</li>
              <li>Naturalization Certificate of the Mother with official English translation - Einbürgerungsurkunde (request <a href="https://www.linguation.com/?gad_source=1&gclid=Cj0KCQiAkKqsBhC3ARIsAEEjuJgvEnQOGj_aAfwVPKKdq4Ci3F5xOapB_N_OhK_R1wk6F63zzLjO1sIaAi7mEALw_wcB">here</a>)</li>
              <li>Identification Card of the Filipino Parent - Personalausweis</li>
              <li>Extract from death registration - Auszug aus dem Todesregister (Formule C, request <a href="https://service.berlin.de/dienstleistung/318990/">here</a>)</li>
              <li>My old Philippine Passport (optional)</li>
            </ul>
            </BlockText>
        </BlockContent>
      </Block>
      
      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Steps</BlockSubtitle>
            <BlockText>If you have all the aforementioned documents ready, please follow these steps:
              <ul>
                <li>Submit all the documents to <a href="civilregistry@philippine-embassy.de">civilregistry@philippine-embassy.de</a> for thorough verification.</li>
                <li>Once you receive confirmation of document completeness, prepare four sets of all the required documents.</li>
                <li>Schedule an appointment via <a href="http://philippine-embassy.de/book-an-appointment">http://philippine-embassy.de/book-an-appointment</a> at the Embassy in Berlin under the category "<b>Passport With Application for Report of Birth Only</b>". Please note that both my mother and I must be present at the appointment to sign the affidavits. The Embassy in Berlin is responsible for residents in the following states: Berlin, Brandenburg, Hamburg, Bremen, Saxony, Lower Saxony, Saxony-Anhalt, Schleswig-Holstein, and Mecklenburg-Vorpommern. For residents in all other states, please contact the Philippine Consulate General in Frankfurt (<a href="www.frankfurtpcg.de">www.frankfurtpcg.de</a>).</li>
                <li>You will receive a confirmation email that will prompt you to send an email to <a href="appointment.phembassyberlin@gmail.com">appointment.phembassyberlin@gmail.com</a> with the subject line: "Request for Appointment - Reference Number 123454." In this email, provide your complete contact details and attach scanned copies (or photographs) of the completed application form and all the required documents.</li>
                <li>You will receive another email containing your appointment date and time. In my case, the appointment took approximately 2 hours. Don't forget to bring the four sets of all required documents and the original documents.</li>
                <li>Finally, you will receive an email notification informing you that your passport is ready for pickup.</li>
              </ul>
            </BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent>
            <BlockSubtitle>Costs</BlockSubtitle>

            <BlockText>
            <table>
        <thead>
          <tr>
            <th style={{padding: "10px"}}>Service</th>
            <th style={{padding: "10px"}}>Price in €</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{padding: "10px"}}>Report of Birth</td>
            <td style={{padding: "10px"}}>22.50</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>PSA-issued Negative Certification of Birth (CRS Form No. 1)</td>
            <td style={{padding: "10px"}}>18.34</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>PSA-issued Negative Certification of Birth (CRS Form No. 1, mother)</td>
            <td style={{padding: "10px"}}>18.34</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>PSA-issued Negative Certification of Marriage (CRS Form No. 3, parents)</td>
            <td style={{padding: "10px"}}>18.34</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>English Translation: Einbürgerungsurkunde</td>
            <td style={{padding: "10px"}}>65.70</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Affidavit of Explanation</td>
            <td style={{padding: "10px"}}>22.50</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Affidavit of delayed Registration</td>
            <td style={{padding: "10px"}}>22.50</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Extract from birth registration - Auszug aus dem Geburtseintrag (Formule A)</td>
            <td style={{padding: "10px"}}>12.00</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Extract from marriage registration - Auszug aus dem Heiratseintrag (Formule B)</td>
            <td style={{padding: "10px"}}>12.00</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Extract from death registration - Auszug aus dem Todesregister (Formule C)</td>
            <td style={{padding: "10px"}}>12.00</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Processing Fee for Passport Application</td>
            <td style={{padding: "10px"}}>66.00</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>Processing Fee for Registration of Birth</td>
            <td style={{padding: "10px"}}>27.50</td>
          </tr>
          <tr>
            <td style={{padding: "10px"}}>TOTAL</td>
            <td style={{padding: "10px"}}>317.72</td>
          </tr>
        </tbody>
      </table>
          </BlockText>
        </BlockContent>
      </Block>

      <Footer/>
                 
    </div>
  );
}

export default Passport;
